module.exports = __webpack_public_path__ + "dist/img/tax-coin.ebcdc172.png";